import { render, staticRenderFns } from "./BeschermdWonen.vue?vue&type=template&id=a566a5e0&scoped=true&"
import script from "./BeschermdWonen.vue?vue&type=script&lang=js&"
export * from "./BeschermdWonen.vue?vue&type=script&lang=js&"
import style0 from "./BeschermdWonen.vue?vue&type=style&index=0&id=a566a5e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a566a5e0",
  null
  
)

export default component.exports